import React, { useState } from 'react';
import { Button, SectionHeading, Spinner, ErrorMessage } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { earlySettlementPagePath } from 'components/navigation/paths';
import { CpDataApi } from 'cp-xhr';
import { getEarlySettlementEndpoint } from 'cpie-common';
import { useAnalyticsActionTracker } from '@cp-shared-15/frontend-ui';

type EarlySettlementRedirectionSectionProps = {
    encryptedContractNumber: string;
};

export const EarlySettlementRedirectionSection: React.FC<EarlySettlementRedirectionSectionProps> = ({
    encryptedContractNumber,
}) => {
    const { onAction: onGetSettlement } = useAnalyticsActionTracker('onDashboardGetSettlement');
    const { t } = useTranslation('financial-details');
    const { t: cms } = useTranslation('dashboard-cms');
    const history = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [settlementError, setSettlementError] = useState<boolean>(false);

    const onGetSettlementButtonClick = async () => {
        onGetSettlement();
        setIsLoading(true);
        CpDataApi.get(getEarlySettlementEndpoint(encryptedContractNumber))
            .then(() => {
                setIsLoading(false);
                history.push(earlySettlementPagePath(encryptedContractNumber));
            })
            .catch(() => {
                setIsLoading(false);
                setSettlementError(true);
            });
    };

    return (
        <React.Fragment>
            <div className="u-float-left">
                <SectionHeading level={3}>{cms('financial-details.get-settlement-section.headline')}</SectionHeading>
            </div>

            <div className="u-float-right">
                <Button
                    type="button"
                    secondary
                    onClick={onGetSettlementButtonClick}
                    disabled={isLoading || settlementError}
                >
                    {isLoading ? <Spinner small /> : cms('financial-details.get-settlement-section.button')}
                </Button>
            </div>

            {settlementError && (
                <div className="u-float-left">
                    <ErrorMessage>{t('get-settlement-section.settlement-error')}</ErrorMessage>
                </div>
            )}
        </React.Fragment>
    );
};
